export const SET_ROVER = 'SET_ROVER';
export const SET_FIELD = 'SET_FIELD';
export const REMOVE_FIELD = 'REMOVE_FIELD';
export const RESET_FIELD_MAP = 'RESET_FIELD_MAP';
export const SET_OBSTACLES = 'SET_OBSTACLES';
export const REMOVE_OBSTACLES = 'REMOVE_OBSTACLES';
export const RESET_OBSTACLES_MAP = 'RESET_OBSTACLES_MAP';
export const SET_POINTS = 'SET_POINTS';
export const REMOVE_POINTS = 'REMOVE_POINTS';
export const RESET_POINTS_MAP = 'RESET_POINTS_MAP';
export const FIELD_RESULT_PAGE_LOADED = 'FIELD_RESULT_PAGE_LOADED';
export const FIELD_RESULT_PAGE_UNLOADED = 'FIELD_RESULT_PAGE_UNLOADED';


